var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({attrs:{"menu-props":{ offsetY: true, overflowY: true, closeOnContentClick: true },"loading":_vm.loading,"items":_vm.data,"item-text":"text","item-value":"value"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }